import { render, staticRenderFns } from "./articalOne.vue?vue&type=template&id=0aa6a3ec&scoped=true"
import script from "./articalOne.vue?vue&type=script&lang=js"
export * from "./articalOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa6a3ec",
  null
  
)

export default component.exports